import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()(({ tokens, px })=>({
        listBox: {
            margin: 0,
            padding: 0
        },
        scrollableWrapper: {
            margin: `${tokens.spacing['8']}px 0`,
            maxHeight: px(270),
            overflow: 'auto'
        }
    }));
const ListBox_styles = useStyles;
export default ListBox_styles;
